import { render, staticRenderFns } from "./RecommendPost.vue?vue&type=template&id=92bbc654&scoped=true&"
import script from "./RecommendPost.vue?vue&type=script&lang=js&"
export * from "./RecommendPost.vue?vue&type=script&lang=js&"
import style0 from "./RecommendPost.vue?vue&type=style&index=0&id=92bbc654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bbc654",
  null
  
)

export default component.exports